/**
 * SAM Sidebar dimension constants
 * Centralized location for all SAM-related sizing
 */

/**
 * SAM-specific colors
 * These are intentionally separate from the theme as they're specific to the SAM interface
 * Note: Using hardcoded values instead of theme references since these are evaluated at module load time
 */
export const SAM_COLORS = {
  /** Dark background color for SAM sidebar, drawers, and related components */
  darkBackground: "#001f28",
  /** Primary purple accent color for SAM UI elements */
  purple: "#8b62ff",
} as const;

/** Width of the minibar (icon strip) */
export const MINIBAR_WIDTH = 123;

/** Height of the sidebar header (matches global topbar height) */
export const SIDEBAR_HEADER_HEIGHT = 68;

/** Height of the SAM input section at the bottom (59px min-height + 24px top margin + 24px bottom margin) */
export const SAM_INPUT_HEIGHT = 107;

/**
 * Width constraints for the resizable sidebar
 */
export const SIDEBAR_WIDTH_CONSTRAINTS = {
  /** Default width for mouse double-click reset */
  DEFAULT: 450,
  /** Default width for touch double-tap reset (smaller for mobile/tablet) */
  TOUCH_DEFAULT: 350,
  /** Minimum sidebar width */
  MIN: 300,
  /** Maximum sidebar width */
  MAX: 800,
  /** Minimum width the page container should maintain */
  MIN_PAGE_CONTAINER: 400,
} as const;

/** Default sidebar width (alias for SIDEBAR_WIDTH_CONSTRAINTS.DEFAULT) */
export const SIDEBAR_WIDTH = SIDEBAR_WIDTH_CONSTRAINTS.DEFAULT;

/** Total width when sidebar is at default width (minibar + sidebar) */
export const TOTAL_SAM_WIDTH = MINIBAR_WIDTH + SIDEBAR_WIDTH;
